import { render, staticRenderFns } from "./AddFeedback.vue?vue&type=template&id=cc2f6424&"
import script from "./AddFeedback.vue?vue&type=script&lang=js&"
export * from "./AddFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports